import { render, staticRenderFns } from "./SaleOrderView.vue?vue&type=template&id=0a0bb95c&"
import script from "./SaleOrderView.vue?vue&type=script&lang=js&"
export * from "./SaleOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports